import api from "../utils/axios";

export const getOrganizations = (params = {}) =>
  api.get("/admin/organizations", { params }); // params: page, limit, search, payment_country (US|IN|"")

export const getOrganization = (orgId) =>
  api.get(`/admin/organizations/${orgId}`);

export const getOrganizationSubscription = (orgId) =>
  api.get(`/admin/organizations/${orgId}/subscription`);

export const createOrganization = (data) =>
  api.post("/admin/businesses", data);

export const updateOrganization = (orgId, data) =>
  api.put(`/admin/organizations/${orgId}`, data);

export const deleteOrganization = (orgId) =>
  api.delete(`/admin/organizations/${orgId}`);

export const addCompanyToOrg = (orgId, data) =>
  api.post(`/admin/organizations/${orgId}/companies`, data);

export const upgradeOrganizationPlan = (orgId, payload) =>
  api.post(`/admin/organizations/${orgId}/upgrade-plan`, payload);
